<div class="container-xl">
  <div *ngIf="!isAutheticated && !isRedirected" class="row">
    <div class="col-xl-5 col-lg-5 col-md-8">
      <app-notifications [target]="'login'" [extraCss]="'shadow mt-6 position-absolute'"></app-notifications>
      <h2 class="mt-6 mb-5">Easy access to reporting and effectiveness of care</h2>
        <div class="row mb-6">
          <div class="col-sm-6" >
            <button id="signInButton" class="btn btn-primary" (click)="redirectToOkta()" >Sign In</button>
          </div>
        </div>
    </div>

    <div class="col-xl-7 col-lg-7 mt-n5 d-none d-lg-block">
      <img class="img-fluid jumbo-img " src="assets/public/images/payer-masked.png" alt="payer-masked" >
    </div>
  </div>
</div>

<div *ngIf="!isAutheticated && !isRedirected" class="bg-secondary-400 pt-7 pb-6 mb-n6">
  <div class="container-xl">
    <h3 class="text-center text-dark mt-0 mb-7">Flexible searches and customizable reports</h3>
    <div class="row">
      <div class="col-md-4">
        <img class="mx-auto d-block mb-4" src="assets/public/images/payer-demographics.svg" alt="Search by demographics" />
        <p class="text-center text-gray-900 mb-6"><strong>Search by demographics</strong></p>
      </div>
      <div class="col-md-4">
        <img class="mx-auto d-block mb-4" src="assets/public/images/payer-analytes.svg" alt="Search by analytes" />
        <p class="text-center text-gray-900 mb-6"><strong>Search by analytes</strong></p>
      </div>
      <div class="col-md-4">
        <img class="mx-auto d-block mb-4" src="assets/public/images/payer-clinical.svg" alt="Search all clinical results" />
        <p class="text-center text-gray-900 mb-6"><strong>Search all clinical results</strong></p>
      </div>
    </div>
  </div>
</div>
